export const subscriberPageTranslations = {
  en: {
    subscriberPage: {
      birthDate: 'Birth date',
      employmentStatus: 'Employment status',
      finish: 'Finish adding card',
      firstName: 'First name',
      lastName: 'Last name',
      mailingAddress: 'Mailing address',
      mobilePhoneNumberOptional: 'Mobile phone number (optional)',
      moreInformation: 'More information',
      notSureQuestion: 'Not sure?',
      primaryPolicyHolderEmployer: 'Employer',
      patientRelationshipToPrimaryPolicyholderTitle:
        'How is the patient related to the person who owns the insurance policy?',
      patientRelationshipToPrimaryPolicyholder:
        "This person is the patient's...",
      primaryPolicyHolderRelationshipToPatient:
        "This patient is the person's...",
      self: 'Self',
      sex: 'Sex',
      someoneElse: 'Someone else',
      title: 'Please select or add the policyholder for this new card.',
      whoIsPolicyholderQuestion: 'Who is the insurance policyholder?',
    },
  },
  es: {
    subscriberPage: {
      birthDate: 'Fecha de nacimiento',
      employmentStatus: 'Estado laboral',
      finish: 'Terminar de agregar la tarjeta',
      firstName: 'Nombre',
      lastName: 'Apellidos',
      mailingAddress: 'Dirección de envio',
      mobilePhoneNumberOptional: 'Número de teléfono celular (opcional)',
      moreInformation: 'Más información',
      notSureQuestion: '¿No estoy segura?',
      primaryPolicyHolderEmployer: 'Empleador',
      patientRelationshipToPrimaryPolicyholderTitle:
        '¿Cómo se relaciona el paciente con la persona propietaria de la póliza de seguro?',
      patientRelationshipToPrimaryPolicyholder:
        'Esta persona, en su relación con el paciente, ocupa el rol de...',
      self: 'Titular',
      sex: 'Sexo',
      someoneElse: 'Alguien más',
      title:
        'Seleccione o agregue el titular de la póliza para esta nueva tarjeta.',
      whoIsPolicyholderQuestion: '¿Quién es el asegurado?',
    },
  },
};
